import { instance } from '../../config/axios';

const actions = {
  getXmacnaLoginUrl() {
    return new Promise((resolve, reject) => {
      instance()
        .get('/auth/xmacna/login')
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  }
};

export default {
  namespaced: true,
  actions
};
